// extracted by mini-css-extract-plugin
export default {"container":"feed-summary-block_container__qwu7X","list":"feed-summary-block_list__uIMly"};